import { Button, styled, Typography } from '@mui/material';

export const Container = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

type UploadImageProps = {
  $hasError?: boolean;
  $borderColor?: string;
  width?: string;
  height?: string;
  disabled?: boolean;
};

export const UploadImage = styled(Button)<UploadImageProps>(
  ({ theme, $hasError, $borderColor, width, height, disabled }) => `
    width: ${width};
    height: ${height};
    border: 1px solid ${
      $hasError
        ? theme.palette.brand.red
        : $borderColor ||
          (disabled && theme.palette.secondary.light) ||
          theme.palette.secondary.dark
    };
    border-radius: 7px;
  
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  
    text-align: center;
  
    gap: 20px;
    padding:0px;
  `,
);

export const Image = styled('img')`
  width: 100%;
  height: 100%;
  background-size: contain;
  background-position: bottom;
  background-repeat: no-repeat;
  border-radius: 6px;
`;

export const StyledFileName = styled(Typography)`
  word-break: break-word;
`;

export const InputTextLabel = styled(Typography)(
  ({ theme }) => `
  font-size: 1rem;
  color: ${theme.palette.secondary.main};
  font-weight: 400;
`,
);
